// 封装后台接口方法
import { get, post } from "./http";
export const GET_NEWS = (params) => get(`/luxetcn/newss/?${params}`);
export const GET_COMMENTS = (params) => post("/luxetcn/comments/", params);
export const GET_PRODUCTS = (params) => get(`/luxetcn/products/?${params}`);
export const GET_NEWS_ID = (params) => get(`/luxetcn/newss/${params}/`);
